import type { ButtonProps } from '@sravni/react-design-system/lib/Button';
import { useBoolean } from '@sravni/react-utils';
import { useMemo } from 'react';

import { useAppSelector } from 'shared/lib';
import type { TOffer } from 'shared/types/TRankingService';

import { selectRegionLocationData } from 'entities/creditForm';
import { currentLocationSelector } from 'entities/locations';
import { createOfferNoteDataFromOffer, offerNoteDataToView } from 'entities/offerNote';
import { OfferDetailsPopup } from 'entities/offerPopups/ui/OfferDetailsPopup/OfferDetailsPopup';

import { getControlsByOffer } from '../../lib';
import { OfferButton } from '../OfferButton/OfferButton';

import { MORE_INFO_TEXTS } from './MoreInfo.texts';

interface IMoreInfoProps {
  offer: TOffer;
  buttonProps?: ButtonProps;
}

export const MoreInfo = ({ offer, buttonProps }: IMoreInfoProps) => {
  const [isPopupOpen, setIsPopupOpen] = useBoolean();
  const headerLocation = useAppSelector(currentLocationSelector);
  const regionLocation = useAppSelector(selectRegionLocationData);
  const noteData = createOfferNoteDataFromOffer(offer);
  const note = offerNoteDataToView(noteData);

  const controls = useMemo(() => getControlsByOffer(offer), [offer]);

  return (
    <>
      <OfferButton
        {...buttonProps}
        variant="secondary"
        color="dark"
        onClick={setIsPopupOpen.toggle}
      >
        {MORE_INFO_TEXTS.LABEL}
      </OfferButton>

      {isPopupOpen && (
        <OfferDetailsPopup
          offer={offer}
          onClose={setIsPopupOpen.off}
          location={regionLocation || headerLocation}
          note={note}
          controls={controls}
        />
      )}
    </>
  );
};
